import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { Public } from '@mui/icons-material';

const GlobalReach = () => {
  const regions = [
    { name: 'North America', cities: ['New York', 'Toronto', 'Los Angeles'] },
    { name: 'Europe', cities: ['London', 'Paris', 'Berlin', 'Zurich'] },
    { name: 'Africa', cities: ['Johannesburg', 'Cape Town', 'Nairobi'] },
    { name: 'Asia Pacific', cities: ['Singapore', 'Sydney', 'Tokyo', 'Shanghai'] },
  ];

  return (
    <Box sx={{ py: 15, background: '#0B0B0B' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
          >
            WORLDWIDE PRESENCE
          </Typography>

          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '2rem', md: '3.5rem' },
            }}
          >
            Global Operations
          </Typography>

          <Typography
            sx={{
              textAlign: 'center',
              maxWidth: '700px',
              mx: 'auto',
              color: '#ccc',
              mb: 8,
            }}
          >
            Operating across four continents with strategic partnerships and
            business connections worldwide.
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {regions.map((region, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
              >
                <Paper
                  sx={{
                    p: 3,
                    background: '#111',
                    textAlign: 'center',
                    border: '1px solid rgba(200,169,107,0.2)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: '#C8A96B',
                    },
                  }}
                >
                  <Public sx={{ fontSize: 48, color: '#C8A96B', mb: 2 }} />
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    {region.name}
                  </Typography>
                  <Box>
                    {region.cities.map((city, i) => (
                      <Typography key={i} variant="body2" sx={{ color: '#999', py: 0.5 }}>
                        {city}
                      </Typography>
                    ))}
                  </Box>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default GlobalReach;